export function formatSortCode(code: string): string {
    const cleaned = code.replace(/\D/g, '');

    if (cleaned.length !== 6) {
        return code;
    }
    // Format into XX-XX-XX
    return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 4)}-${cleaned.slice(4, 6)}`;
}
